import React from 'react';

import { parseDateFromAPIFormat } from '../../common/format';

export const StartDateColumn = ({ i18n }) => ({
  key: 'StartDate',
  name: i18n.getString(_TL_('Start date')),
  fieldName: 'StartDate',
  className: 'column-start-date',
  headerClassName: 'header-start-date',
  minWidth: 120,
  maxWidth: 200,
  sortable: true,
  isMultiline: true,
  isResizable: true,
  onRender: ({ StartDate }) => (
    <span>
      {parseDateFromAPIFormat(i18n, StartDate)}
    </span>
  ),
});
